<template>
  <a-modal :visible="visible" title="New Practice Area" :footer="null" @cancel="visible = false">
    <a-form :form="form" @submit.prevent="handlePracticeArea">
      <a-form-item label="Title">
        <a-input
          v-decorator="['title',{rules: [{ required: true, message: 'This field is required.' }] }]"/>
      </a-form-item>
      <a-divider/>
      <div class="flex space-x-2">
        <a-button type="primary" :loading="loading" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
        <a-button type="primary" ghost @click="visible = false" style="border-radius: 3px !important;">Cancel</a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
  import mixin from '../../../../mixin/mixin'
  import axios from "@/axios";
  export default {
    name: "ModalPracticeArea",
    mixins:[mixin],
    props:{
      edit_mode       : { type : Boolean , default : false },
      row_list        : { type : Object  , required: false },
      getPracticeArea : { type : Function, required: false }
    },
    data(){
      return{
        visible : false,
        loading : false
      }
    },
    methods:{
      handlePracticeArea() {
        this.form.validateFields(async (err, values) => {
          if (!err) {
            try {
              this.loading       = true
              const { row_list } = this
              const {data}       = this.edit_mode ? await axios.put(`/practice-area/${row_list.id}/`, values) : await axios.post('/practice-area/', values)
              this.form.resetFields()
              this.visible = false
              this.$notification['success']({
                message: 'Success',
                description: `Practice Area ${this.edit_mode ? 'updated' : 'created' }.`
              })
              this.$emit('createPracticeArea',data)
              await this.getPracticeArea()
            } catch (e) {
              this.visible = true
              this.$message.error('Server error')
              throw e
            } finally {
              this.loading = false
            }
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
